import { IconFilmnetLogo } from '../../../icons';
import { WatermarkContainer } from '../styles';

const Watermark = () => (
  <WatermarkContainer>
    <IconFilmnetLogo />
  </WatermarkContainer>
);

export default Watermark;
